module.exports = __webpack_public_path__ + "assets/img/page-header-bg@3x.9a3838ed.png";